<form class="auth-page" id="auth-page" (ngSubmit)="login()" ngNativeValidate>
    <div class="many-inputs auth-panel">
        <loading-indicator class="overlay" [isVisible]="isLoading"></loading-indicator>

        <a class="logo" [routerLink]="['/']"><img [src]="settings.getBaseUrl(true) + settings.get('branding.logo_dark')" alt="logo"></a>

        <div class="general-error" *ngIf="errors.general">{{errors.general}}</div>

        <div class="input-container">
            <label for="email" class="hidden"></label>
            <input type="email" [(ngModel)]="model.email" name="email" id="email" required placeholder="Email" trans-placeholder>
            <p class="error email-error" *ngIf="errors.email">{{errors.email}}</p>
        </div>

        <div class="input-container">
            <label for="password" class="hidden"></label>
            <input type="password" [(ngModel)]="model.password" name="password" id="password" required placeholder="Password" trans-placeholder>
            <a class="forgot-password" [routerLink]="['/forgot-password']"><span trans>Forgot</span>?</a>
            <p class="error password-error" *ngIf="errors.password">{{errors.password}}</p>
        </div>

        <div class="remember-and-login-row">
            <div class="remember-me-checkbox">
                <mat-checkbox name="remember-me" [color]="settings.get('vebto.auth.color')" [(ngModel)]="model.remember" trans>Remember Me</mat-checkbox>
            </div>

            <div class="login-button">
                <button mat-raised-button [color]="settings.get('vebto.auth.color')" type="submit" trans>Login</button>
            </div>
        </div>

        <ng-container *ngIf="!settings.get('registration.disable')">
            <p class="info-row">
                <span class="color-secondary"><span trans>Don't have an account</span>?</span>
                <a class="register-link" [routerLink]="['/register']" trans>Register here.</a>
            </p>

            <div class="big-social-auth-button" *ngIf="settings.get('envato.enable'); else defaultSocialAuth">
                <button type="button" mat-raised-button [color]="settings.get('vebto.auth.color')" (click)="socialAuth.loginWith('envato')">
                    <mat-icon svgIcon="envato-custom"></mat-icon>
                    <span trans>Login With Envato</span>
                </button>
            </div>

            <ng-template #defaultSocialAuth>
                <div class="social-icons center">
                    <button type="button" mat-icon-button (click)="socialAuth.loginWith('facebook')" *ngIf="settings.get('social.facebook.enable')" class="social-icon no-style facebook" [matTooltip]="'Login with facebook' | trans">
                        <mat-icon svgIcon="facebook-custom"></mat-icon>
                    </button>
                    <button type="button" mat-icon-button (click)="socialAuth.loginWith('google')" *ngIf="settings.get('social.google.enable')" class="social-icon no-style google" [matTooltip]="'Login with google' | trans">
                        <mat-icon svgIcon="google-custom"></mat-icon>
                    </button>
                    <button type="button" mat-icon-button (click)="socialAuth.loginWith('twitter')" *ngIf="settings.get('social.twitter.enable')" class="social-icon no-style twitter" [matTooltip]="'Login with twitter' | trans">
                        <mat-icon svgIcon="twitter-custom"></mat-icon>
                    </button>
                </div>
            </ng-template>
        </ng-container>
    </div>
</form>

